export default {
   components: {},
   routes: [
      {
         path: '/',
         component: () => import(`./dashboard`),
         name: 'Dashboard'
      },
      // Users
      {
         path: '/user/users',
         component: () => import(`./users/users`),
         name: 'Admin_Users'
      },

      // Configs
      {
         path: '/configs/fuel-stations',
         component: () => import(`./configs/fuelStations`),
         name: 'Fuel_Stations'
      },
      {
         path: '/configs/pump-attendants',
         component: () => import(`./configs/pumpAttendants`),
         name: 'Pump_Attendants'
      },
      {
         path: '/configs/payment-options',
         component: () => import(`./configs/paymentOptions`),
         name: 'Payment_Options'
      },

      // Reports
      {
         path: '/reports/transactions-date',
         component: () => import(`./reports/transactionsByDate`),
         name: 'Transactions_By_Date'
      },
      {
         path: '/reports/transactions-id',
         component: () => import(`./reports/transactionsByID`),
         name: 'Transactions_By_ID'
      },
      {
         path: '/reports/users-registered',
         component: () => import(`./reports/usersRegistered`),
         name: 'Customers_Registered'
      },
      {
         path: '/reports/view-customer',
         component: () => import(`./reports/viewCustomer`),
         name: 'Customers_Registered-View_Customer'
      },
      {
         path: '/reports/promo-codes',
         component: () => import(`./reports/promoCodes`),
         name: 'Promo_Codes'
      },
   ]
}